<template>
  <div class="perfumist-product">
    <v-row v-if="!isValidated && !isCreateRequest">
      <v-col>
        <v-alert
          class="pl-6"
          :color="visitedTabs.length === 3 ? 'success' : 'warning'"
          border="left"
          elevation="2"
          colored-border
          :icon="
            visitedTabs.length === 3
              ? 'mdi-progress-check'
              : 'mdi-progress-alert'
          "
        >
          Please verify all the details initiated for this product. Feel free to
          update and validate when you have finished.
          <v-chip
            small
            class="float-right my-0"
            outlined
            :color="visitedTabs.length === 3 ? 'success' : 'warning'"
          >
            <v-icon left
              >mdi-checkbox-multiple-{{
                visitedTabs.length === 3 ? "marked" : "blank"
              }}-circle-outline</v-icon
            >
            {{ visitedTabs.length }}/3 tabs visited
          </v-chip>
        </v-alert>
      </v-col>
    </v-row>

    <v-tabs class="product-slider" v-model="tab" show-arrows>
      <v-tabs-slider color="primary"></v-tabs-slider>
      <!--      Removed Variants from list -->
      <v-tab
        :ripple="false"
        :key="i"
        v-for="(t, i) in ['Description', 'Images', 'Attributes']"
      >
        <v-badge
          v-if="
            (differences.descriptionTab && t == 'Description') ||
              (differences.imagesTab && t == 'Images') ||
              (differences.attributesTab && t == 'Attributes')
          "
          color="pink"
          icon="mdi-pencil"
        >
          {{ t }}
        </v-badge>

        <template v-else>{{ t }}</template>
      </v-tab>
    </v-tabs>
    <v-card min-height="500px" class="px-6 py-4">
      <v-slide-y-transition>
        <v-tabs-items v-model="tab" v-if="productValue">
          <v-tab-item eager :value="0">
            <ProductDescription
              :is-form="isForm"
              :rules="rules"
              @addLocale="l => $emit('addLocale', l)"
              :tab-index="langTabIndex"
              @onTabChange="t => (langTab = t)"
              :valueRef="valueRef ? valueRef.data.locales : null"
              v-model="productValue.data.locales"
              :read-only="readOnly"
              :differences="differences"
              :isCreateRequest="!isCreateRequest"
            />
          </v-tab-item>
          <v-tab-item eager :value="1">
            <ProductImages
              :is-form="isForm"
              :rules="rules"
              v-model="productValue.data.images"
              :read-only="readOnly"
              :differences="differences"
            />
          </v-tab-item>
          <v-tab-item eager :value="2">
            <ProductAttributes
              :is-form="isForm"
              :rules="rules"
              v-model="productValue"
              :read-only="readOnly"
              :differences="differences"
            />
          </v-tab-item>
          <!--          <v-tab-item eager :value="3">-->
          <!--            <ProductVariants-->
          <!--              v-model="productValue.data.variants"-->
          <!--              :read-only="readOnly"-->
          <!--            />-->
          <!--          </v-tab-item>-->
        </v-tabs-items>
      </v-slide-y-transition>
    </v-card>
  </div>
</template>

<script>
import ProductDescription from "@/components/perfumist/product/ProductDescription"
import ProductAttributes from "@/components/perfumist/product/ProductAttributes"
import ProductImages from "@/components/perfumist/product/ProductImages"
// import ProductVariants from "@/components/perfumist/product/ProductVariants"
export default {
  components: {
    ProductDescription,
    ProductAttributes,
    ProductImages
    // ProductVariants
  },
  props: {
    valueRef: {
      type: Object,
      default: null
    },
    value: {
      type: Object,
      default: null
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    tabIndex: {
      type: Number,
      default: 0
    },
    langTabIndex: {
      type: String,
      default: "tab-en"
    },
    isForm: {
      type: Boolean,
      default: true
    },
    isCreateRequest: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    differences: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visitedTabs: [0],
      tab: 0,
      langTab: "tab-1",
      productValue: null
      // productValue: {
      //   variants: [
      //     {
      //       ean: "",
      //       id: "",
      //       image: "",
      //       name: "",
      //       size: "",
      //       locale: "",
      //       price: "",
      //       currency: ""
      //     }
      //   ],
      //   attributes: {
      //     category: "",
      //     discontinued: false,
      //     gender: "",
      //     concentration: "",
      //     date_of_lunch: "",
      //     discontinuated_at: "",
      //     perfume: ""
      //   }
      // }
    }
  },
  mounted() {
    this.tab = 0
  },
  created() {
    this.productValue = this.lo.cloneDeep(this.value)
  },
  watch: {
    isFormValid(newValue) {
      this.$emit("update:form", newValue)
    },
    productValue(newValue, oldValue) {
      if (newValue !== null && !this.readOnly) this.$emit("input", newValue)
    },
    value: {
      deep: true,
      handler(newValue, oldValue) {
        if (
          !this.lo.isEqual(newValue, this.productValue) ||
          this.productValue === null
        )
          this.productValue = this.lo.cloneDeep(newValue)
      }
    },
    tabIndex(newValue, oldValue) {
      this.tab = newValue
      if (!this.visitedTabs.includes(newValue)) this.visitedTabs.push(newValue)
    },
    tab(newValue, oldValue) {
      this.$emit("onTabChange", newValue)
    },
    langTabIndex(newValue, oldValue) {
      this.langTab = newValue
    },
    langTab(newValue, oldValue) {
      this.$emit("onLangTabChange", newValue)
    }
  },
  computed: {
    isValidated() {
      return !!this.value?.validated
    }
  }
}
</script>

<style lang="scss" scoped></style>
